<template>
  <b-modal
    ref="modal"
    size="xl"
    hide-footer
    title="Modificar Chip"
    @hidden="reset"
    lazy
  >
    <form
      v-promise-btn="{ action: 'submit' }"
      @submit.prevent="submit"
      v-if="chip"
    >
      <div class="container h-100">
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="id">ID</label>
              <input
                v-model="chip.id_chip"
                disabled
                type="text"
                class="form-control"
                id="id"
              />
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="fecha_ingreso">Fecha de Ingreso</label>
              <input
                v-model="chip.fecha_ingreso"
                disabled
                type="datetime-local"
                class="form-control"
                id="fecha_ingreso"
              />
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="fecha_baja">Fecha de Baja</label>
              <input
                v-model="chip.fecha_baja"
                disabled
                type="datetime-local"
                class="form-control"
                id="fecha_baja"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="numero">Número</label>
              <input
                disabled
                v-model="chip.numero"
                type="text"
                class="form-control"
                id="numero"
              />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="imsi">IMSI</label>
              <input
                disabled
                v-model="chip.IMSI"
                type="text"
                class="form-control"
                id="imsi"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="empresa">Empresa</label>
              <input
                disabled
                v-model="chip.empresa"
                type="text"
                class="form-control"
                id="empresa"
              />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="plan">Plan</label>
              <input
                disabled
                v-model="chip.plan"
                type="text"
                class="form-control"
                id="plan"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="ubicacion">Ubicación</label>
              <input
                type="text"
                class="form-control"
                v-model="chip.ubicacion"
                id="ubicacion"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="w-100 d-flex justify-content-end">
        <button type="button" class="btn btn-danger" @click="closeModal">
          Cancelar
        </button>
        <button type="submit" class="btn btn-primary">Guardar</button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import axios from "axios";

export default {
  name: "ModificarChip",
  computed: {
    chip: {
      get() {
        return this.$store.state.chips.chipForModify;
      },
      set(val) {
        this.$store.commit("chips/setChipForModify", val);
      },
    },
  },
  watch: {
    chip: {
      handler(newVal) {
        this.$store.commit("chips/setChipForModify", newVal);
      },
      deep: true,
    },
  },
  methods: {
    async submit() {
      const fd = new FormData();
      fd.append("chip", JSON.stringify(this.chip));
      fd.append("_method", "patch");

      return axios.post(`/chips/${this.chip.id_chip}`, fd).then((response) => {
        this.$emit("chipUpdated", response.data);
        this.closeModal();
      });
    },
    reset() {
      this.$store.commit("chips/setChipForModify", null);
    },
    closeModal() {
      this.$refs.modal.hide();
    },
  },
};
</script>

<style scoped></style>
